import type { ChatMessage } from '../lib/types';

interface Props {
  message: ChatMessage;
  partial?: boolean;
}

export function Message({ message, partial }: Props) {
  const isUser = message.role === 'user';
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[85%] sm:max-w-[75%] px-4 py-2 rounded-2xl whitespace-pre-wrap break-words text-[15px] leading-relaxed ${
          isUser ? 'bg-blue-600 text-white' : 'bg-gray-900 text-gray-100 border border-gray-800'
        }`}
      >
        {message.content}
        {partial && (
          <span className="inline-block w-1.5 h-4 bg-gray-400 ml-1 align-middle animate-pulse" />
        )}
      </div>
    </div>
  );
}
